import { Court } from './Court'
import Image from './Image'
import Location from './Location'
import Sport from './Sport'
import Trainer from './Trainer'
import Venue from './Venue'

export enum EventType {
  CAMP = 'Camp',
  CLASS = 'Class',
  COURSE = 'Course',
  EDUCATION = 'Education',
  EVENT = 'Event',
  OPENTRAINING = 'OpenTraining',
  PRIVATE = 'Private',
  RETREAT = 'Retreat',
  TRAINING = 'Training',
  WORKSHOP = 'Workshop',
}

export interface CourtBookableItem {
  __typename: 'CourtBookableItem'
  id: string
  venue: Venue
  sport: Sport
  court: Court
  activityImage: Image | null
  timeRange: TimeRange
  cancellationCondition: string
}

export interface EventBookableItem {
  __typename: 'EventBookableItem'
  id: string
  venue: Venue
  sport: Sport
  activityName: string
  location: Location
  trainer: Array<Trainer> | null
  activityImage: Image | null
  eventSessions: Array<EventSession>
  cancellationCondition: string
  eventType?: EventType
  description?: { plainText: string } | null
  bookingType: ActivityBookingType
}

export interface TimeRange {
  start: string
  end: string
}

interface EventSession extends TimeRange {
  id: string
  name: string | null
  hasOnlineStream?: boolean
  court?: Court | null
  trainer?: Trainer | null
}

export enum ActivityBookingType {
  DIRECT = 'DIRECT',
  REQUEST = 'REQUEST',
}

export type AssignedSpot = {
  __typename: 'Spot'
  id: string
  label: string
} | null

type BookableItem = CourtBookableItem | EventBookableItem

export default BookableItem
